'use client';

import * as React from 'react';

import { useTranslations } from 'next-intl';

import { CloseButton } from '@/components/overlay/CloseButton';
import { SmartModal } from '@/components/overlay/SmartModal';
import { P } from '@/components/shared/Typography';
import { Button } from '@/components/ui/button';

type T_DeleteConfirmationDialogProps = {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  trigger?: React.ReactNode;
  onConfirmDelete?: () => void;
  isDeleting?: boolean;
};

export function DeleteConfirmationDialog({
  open,
  onOpenChange,
  trigger,
  onConfirmDelete,
  isDeleting
}: T_DeleteConfirmationDialogProps) {
  const t = useTranslations('editProfile');

  const handleConfirmDelete = () => {
    if (onConfirmDelete) {
      onConfirmDelete();
    }
  };

  return (
    <SmartModal
      open={open}
      onOpenChange={onOpenChange}
      trigger={trigger}
      dialogType="dialog"
      variant="glass"
      a11yTitle={t('confirmation.title')}
      showClose={false}
      className="w-full md:max-w-107"
    >
      <div className="grid card-border-gradient rounded-2xl">
        <div className="flex p-7 justify-between items-center">
          <P className="text-foreground text-lg font-bold leading-none">
            {t('confirmation.title')}
          </P>
          <CloseButton className="flex items-center justify-center w-8 h-8 relative  right-0 top-0 " />
        </div>
        <div className="grid p-7 border-y-1 gap-2">
          <P className="text-base font-bold leading-normal">
            {t('confirmation.deleteWarning')}
          </P>
          <P className="text-base font-normal leading-normal">
            {t('confirmation.deleteNote')}
          </P>
        </div>
        <div className="grid px-7 py-6 justify-center">
          <Button
            variant="destructive"
            onClick={handleConfirmDelete}
            disabled={isDeleting}
            className="w-full"
          >
            {isDeleting ? t('confirmation.deleting') : t('confirmation.delete')}
          </Button>
        </div>
      </div>
    </SmartModal>
  );
}
